import { useNavigate } from "react-router-dom";
import { url } from "../../Config";
import useTestBuilder from "../Utils/testbuilder/useTestBuilder";
import TestBuilderLayout from "../Utils/testbuilder/TestBuilderLayout";

const TestCreator = () => {
  const navigate = useNavigate();
  const builder = useTestBuilder();

  const submitTest = async () => {
    const token = JSON.parse(localStorage.getItem("auth"))?.token;

    const response = await fetch(`${url}/api/create-test`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        testName: builder.testName,
        testDescription: builder.testDescription,
        testInstructions: builder.testInstructions,
        testTimeLimit: builder.testTimeLimit,
        questions: builder.questions,
        gradeRules: builder.gradeRules,
        private: builder.isPrivate,
        modifications: builder.modifications,
      }),
    });

    if (response.ok) {
      alert("Created!");
      navigate("/home");
    }
  };

  return (
    <TestBuilderLayout
      builder={builder}
      onSubmit={submitTest}
      mode="create"
    />
  );
};

export default TestCreator;
